import { useState } from "react";
import {
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from "@fluentui/react-components";
import { CalendarLtr16Regular } from "@fluentui/react-icons";
import { Calendar } from "@fluentui/react-calendar-compat";
import { IFilterDatePopoverProps } from "./FilterDatePopover.types";
import { useStyles } from "./FilterDatePopover.styles";
import { PopupActionFooter } from "./PopupActionFooter";
import { formatFilterDate } from "../../utils/filterHelpers";

export const FilterDatePopover = ({
  value,
  ariaLabel,
  minDate,
  maxDate,
  disabled = false,
  onApply,
}: IFilterDatePopoverProps): JSX.Element => {
  const styles = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [draftDate, setDraftDate] = useState<Date>(value);

  const handleOpenChange = (open: boolean): void => {
    if (open) {
      setDraftDate(value);
      setIsOpen(true);
      return;
    }
    // Dismiss (Escape / click-away) discards the draft.
    setIsOpen(false);
  };

  const handleApply = (): void => {
    onApply(draftDate);
    setIsOpen(false);
  };

  const handleCancel = (): void => {
    setDraftDate(value);
    setIsOpen(false);
  };

  return (
    <Popover
      open={isOpen}
      onOpenChange={(_e, data) => handleOpenChange(data.open)}
      trapFocus
      withArrow
      positioning="below"
    >
      <PopoverTrigger disableButtonEnhancement>
        <button
          type="button"
          className={styles.trigger}
          disabled={disabled}
          aria-label={`${ariaLabel}: ${formatFilterDate(value)}`}
        >
          {formatFilterDate(value)}
          <CalendarLtr16Regular
            className={styles.triggerIcon}
            aria-hidden="true"
          />
        </button>
      </PopoverTrigger>
      <PopoverSurface className={styles.surface}>
        <Calendar
          value={draftDate}
          minDate={minDate}
          maxDate={maxDate}
          onSelectDate={(date) => setDraftDate(date)}
        />
        <PopupActionFooter onApply={handleApply} onCancel={handleCancel} />
      </PopoverSurface>
    </Popover>
  );
};
